export { PipesModule } from './pipes.module';
export * from './array.pipes';
export * from './normal-column.pipe';